"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M42.9166 19.7917L29.5833 7.5C27.0833 5.20833 23.125 5.20833 20.625 7.5L7.08331 19.7917C5.62498 21.0417 4.99998 22.9167 4.99998 24.7917V37.5C4.99998 41.25 7.91664 44.1667 11.6666 44.1667H19.5833V29.5833C19.5833 28.9583 20.2083 28.3333 20.8333 28.3333H29.1666C29.7916 28.3333 30.4166 28.9583 30.4166 29.5833V44.1667H38.3333C42.0833 44.1667 45 41.25 45 37.5V24.7917C45.2083 22.9167 44.375 21.0417 42.9166 19.7917ZM42.2916 37.5C42.2916 39.5833 40.625 41.25 38.5416 41.25H32.9166V29.5833C32.9166 27.5 31.25 25.8333 29.1666 25.8333H20.8333C18.75 25.8333 17.0833 27.5 17.0833 29.5833V41.25H11.4583C9.37498 41.25 7.70831 39.5833 7.70831 37.5V24.7917C7.70831 23.75 8.12498 22.7083 8.95831 21.875L22.5 9.58333C23.3333 8.95833 24.1666 8.54167 25 8.54167C25.8333 8.54167 26.875 8.95833 27.5 9.58333L40.8333 21.875C41.6666 22.5 42.0833 23.5417 42.0833 24.7917V37.5H42.2916Z",
    fill: fill
  }));
};

exports["default"] = _default;